import React, { useRef } from "react";

const SortModal = ({ setSort, value }) => {
  const ref = useRef();

  return (
    <div
      ref={ref}
      id="sortModal"
      className="absolute top-56 sm:top-7 right-1/2 sm:right-0 transform translate-x-1/2 sm:transform-none  z-50 rounded-md p-4 shadow-2xl bg-white w-72 flex flex-col gap-4 text-black"
      onMouseLeave={() => {
        ref.current.style.opacity = null;
        ref.current.style.display = null;
      }}
    >
      <div className="flex justify-between">
        <h1 className="font-semibold text-xl">Sort:</h1>
        <div
          onClick={() => {
            ref.current.style.opacity = "0";
            setTimeout(() => {
              ref.current.style.display = "none";
            }, 200);
          }}
        >
          <span className="cursor-pointer px-2 select-none">x</span>
        </div>
      </div>

      <p className="self-start">by:</p>
      <div className={`flex flex-col p-1 border-indigo-500 border-2 rounded`}>
        <button
          className={`transition-colors py-1 rounded ${
            value === "-cost" && "text-white bg-indigo-500"
          }`}
          onClick={(e) => setSort(e.target.value)}
          value="-cost"
        >
          Price: High to Low
        </button>
        <button
          className={`transition-colors py-1 rounded ${
            value === "cost" && "text-white bg-indigo-500"
          }`}
          onClick={(e) => setSort(e.target.value)}
          value="cost"
        >
          Price: Low to High
        </button>
        <button
          className={`transition-colors py-1 rounded ${
            value === "rating" && "text-white bg-indigo-500"
          }`}
          onClick={(e) => setSort(e.target.value)}
          value="rating"
        >
          Ratings/Likes
        </button>
        <button
          className={`transition-colors py-1 rounded ${
            value === "name" && "text-white bg-indigo-500"
          }`}
          onClick={(e) => setSort(e.target.value)}
          value="name"
        >
          Alphabet
        </button>
        <button
          className={`transition-colors py-1 rounded ${
            value === "dateAdded" && "text-white bg-indigo-500"
          }`}
          onClick={(e) => setSort(e.target.value)}
          value="dateAdded"
        >
          Date Added
        </button>
      </div>
    </div>
  );
};

export default SortModal;
